<template>
  <div class="jump-usercenter nav-bar-fixed">
    <van-nav-bar title="商品发运计划" left-arrow fixed @click-left="back">
      <!-- <div slot="right" class="jump-nav-bar-rhd">
      </div>-->
    </van-nav-bar>
    <!-- <div v-if="list.length==0">暂无发运信息</div>-->

    <van-collapse v-model="activeName" v-for="(item,index) in list">
      <van-collapse-item :title="title[index]" :name="index">
        <van-row class="jump-messg-item" v-for="obj in goodInfo[index]">
          <van-col span="24">
            <van-cell title="商品名称" :value="obj.goodName" />
            <van-cell v-if="obj.spec&&obj.spec!=''" title="规格" :value="obj.spec" />
            <van-cell title="计划发货数量" :value="obj.num" />
          </van-col>
          <van-col span="24" v-if="transport=='管车宝'">
            <van-cell title="管车宝运费" :value="obj.price" />
          </van-col>
        </van-row>

        <van-row class="jump-messg-item">
          <van-col span="24">
            <van-cell title="车次安排" :value="item.trainType==1?'专车':'拼车'" />
            <van-cell title="车牌号" :value="item.plateNo" />
            <van-cell title="司机手机号" :value="item.mobileDriver" />
            <van-cell title="发车时间" :value="item.departureTime" />
            <van-cell title="司机姓名" :value="item.driverName" />
            <van-cell title="司机身份证号" :value="item.driverIdnumber" />
          </van-col>
        </van-row>
      </van-collapse-item>
    </van-collapse>

    <van-collapse v-model="activeNames" v-if="showType==1">
      <van-collapse-item title="创建发运计划" name="2">
        <van-row class="jump-messg-item" v-for="(obj,index) in ordergoods">
          <van-col span="24">
            <van-cell title="商品名称" :value="obj.goods_name" />
            <van-cell v-if="obj.spec&&obj.spec!=''" title="规格" :value="obj.spec" />
            <van-cell title="订货数量" :value="obj.count" />
            <van-field v-model="planlist[index]" label="计划发货数量" />
          </van-col>
          <van-col span="24" v-if="transport=='管车宝'">
            <van-field v-model="ship_price[index]" label="管车宝运费" placeholder="请输入管车宝运费" />
          </van-col>
        </van-row>
        <van-row class="jump-messg-item">
          <van-row>
            <van-radio-group v-model="chetype">
              <van-cell-group>
                <van-cell title="车次安排">
                  <van-radio name="1" style="float: left">专车</van-radio>
                  <van-radio name="2" style="float: left">拼车</van-radio>
                </van-cell>
              </van-cell-group>
            </van-radio-group>

            <van-cell-group>
              <van-field v-model="cheCode" label="车牌号" placeholder="请输入车牌号" @blur="getPhone" />

              <van-field v-model="phone" label="司机手机号" placeholder="请输入司机手机号" />
            </van-cell-group>

            <van-field
              v-model="birthday"
              label="发车时间"
              placeholder="请选择"
              @focus="showDate"
              readonly
            />
            <van-field v-model="driverName" label="司机姓名" placeholder="请输入司机姓名" />
            <van-field v-model="driverIdnumber" label="司机身份证号" placeholder="请输入司机身份证号" />

            <van-cell title="快捷录入" />
            <van-field
              type="textarea"
              v-model="speedy_input"
              @blur="getspeedy_input"
              placeholder="请输入快捷录入信息(逗号分隔)"
            />

            <van-popup v-model="popDateShow" position="bottom" :overlay="true">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                @cancel="popDateShow = false"
                @confirm="onDateConfirm"
              />
            </van-popup>
          </van-row>
        </van-row>
        <van-col span="24">
          <van-button type="info" size="large" class="blues" @click="saveShipmentPlan">保存</van-button>
        </van-col>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import {
  Panel,
  Uploader,
  Button,
  Cell,
  CellGroup,
  Col,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  NavBar,
  Picker,
  Popup,
  Radio,
  RadioGroup,
  Row,
  Switch,
  Tab,
  Tabs
} from "vant";

export default {
  name: "usermessage",
  components: {
    [Panel.name]: Panel,
    [Dialog.name]: Dialog,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Uploader.name]: Uploader,
    [Switch.name]: Switch
  },
  data() {
    return {
      ship_price: [],
      transport: this.$route.query.transport,
      activeName: this.$route.query.type == 2 ? [0] : ["-1"],
      activeNames: ["2"],
      showType: this.$route.query.type,
      workflowId: this.$route.query.workflowId,
      ordergoods: JSON.parse(localStorage.getItem("ordergoodsPlan")),
      type: JSON.parse(localStorage.getItem("type")),
      planlist: [],
      list: [],
      chetype: "1",
      cheCode: "",
      phone: "",
      birthday: "",
      driverName: "",
      driverIdnumber: "",
      speedy_input: "",
      popDateShow: false,
      currentDate: new Date(),
      title: [],
      goodInfo: []
    };
  },
  mounted() {
    let that = this;
    that.lookShipmentPlan();
    that.planlist = [];
    for (var i = 0; i < that.ordergoods.length; i++) {
      that.planlist[i] = that.ordergoods[i].count;
    }
  },
  created() {
    this.onDateConfirm(this.currentDate);
  },
  methods: {
    back() {
      history.back();
    },
    lookShipmentPlan() {
      let that = this;
      that.$api.post(
        that.jumuc.plan.lookShipmentPlan,
        { workflowId: that.workflowId },
        successRes => {
          if (successRes.success) {
            that.list = successRes.data;
            for (var i = 0; i < that.list.length; i++) {
              let k = i + 1;
              that.title[i] = "发运计划日志" + k;
              let goodJons = that.list[i].goodsJson.split("@");
              let goodDelivery = [];
              for (var j = 0; j < goodJons.length; j++) {
                let good = goodJons[j].split(",");
                let json = {};
                if (good[0] != "") {
                  json["goodName"] = good[0];
                  json["num"] = good[1];
                  json["price"] = good[3];
                  json["spec"] = good[4];
                  goodDelivery[j] = json;
                }
              }
              that.goodInfo[i] = goodDelivery;
            }
          }
        }
      );
    },
    saveShipmentPlan() {
      let that = this;
      let str = "";
      for (var i = 0; i < that.ordergoods.length; i++) {
        let price = 0;
        let spec = "";
        try {
          price = that.ship_price[i];
          if (price == null || price.trim() == "") {
            price = 0;
          }
        } catch (e) {
          price = 0;
        }
        if (that.ordergoods[i].spec) {
          spec = that.ordergoods[i].spec;
        }
        str =
          str +
          that.ordergoods[i].goods_name +
          "," +
          that.planlist[i] +
          "," +
          that.ordergoods[i].goodsId +
          "," +
          price +
          "," +
          spec +
          "@";
      }
      let json = {};
      json["workflowId"] = that.workflowId;
      json["goodsJson"] = str;
      json["trainType"] = that.chetype;
      json["plateNo"] = that.cheCode;
      json["mobileDriver"] = that.phone;
      json["departureTime"] = that.birthday;
      json["driverName"] = that.driverName;
      json["driverIdnumber"] = that.driverIdnumber;
      that.$api.post(that.jumuc.plan.saveShipmentPlan, json, successRes => {
        Dialog.alert({
          title: "",
          message: successRes.msg
        }).then(() => {
          that.lookShipmentPlan();
        });
      });
    },
    showDate() {
      this.popDateShow = true;
    },
    onDateConfirm(value) {
      const d = new Date(value);
      const resDate =
        d.getFullYear() +
        "-" +
        this.p(d.getMonth() + 1) +
        "-" +
        this.p(d.getDate());
      const resTime =
        this.p(d.getHours()) +
        ":" +
        this.p(d.getMinutes()) +
        ":" +
        this.p(d.getSeconds());
      this.birthday = resDate + " " + resTime;
      this.popDateShow = false;
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    getPhone() {
      //根据车牌号获取手机号
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.getDriver,
        { carNumber: that.cheCode },
        successRes => {
          that.phone = successRes.data.driver_mobile;
          that.cheCode = successRes.data.driver_car_number;
          that.driverName = successRes.data.driver_name;
          that.driverIdnumber = successRes.data.driver_idnumber;
        }
      );
    },
    getspeedy_input() {
      let that = this;
      that.speedy_input = that.speedy_input.replace(/，|,/g, ",");
      let arry = [];
      arry = that.speedy_input.split(",");
      that.cheCode = arry[2];
      that.birthday = arry[4];
      that.phone = arry[1];
      that.driverName = arry[0];
      that.driverIdnumber = arry[3];
    }
  }
};
</script>
<style lang="less">
@bule-thame: #3c6eeb;

body {
  background-color: #f7f7f7;
}

.jump-nav-bar-rhd {
  color: #fff;
  font-size: 16px;
  i {
    font-size: 20px;
  }
  span {
    margin-left: 5px;
  }
  span,
  i {
    vertical-align: middle;
  }
}

.van-nav-bar__text {
  font-size: 16px;
  padding: 0;
  margin: 0;
}

.van-icon-calender-o {
  font-size: 24px;
  position: fixed;
  top: 10px;
  right: 60px;
  color: #fff;
  z-index: 1000000;
}

.jump-usercenter {
  padding-top: 50px;
}

.jump-messg-item {
  padding: 15px 10px;
  border-radius: 15px;
  background-color: #fff;
  margin-top: 10px;
  p {
    font-size: 14px;
    span {
      color: #333;
    }
  }
  p.item-cont {
    font-size: 14px;
    color: rgb(208, 2, 27);
    font-family: PingFangSC-Regular;
    padding-bottom: 10px;
    span {
      margin-right: 20px;
    }
  }
  .van-button {
    padding: 0 15px;
    background-color: @bule-thame;
    border-color: @bule-thame;
    color: #fff;
    font-size: 14px;
    border-radius: 8px;
  }
  .item-header {
    color: @bule-thame;
    font-size: 16px;
    margin-bottom: 10px;
    span {
      margin-left: 10px;
      color: @bule-thame;
      &.noread {
        color: red;
      }
    }
  }
  .item-time {
    font-size: 16px;
    text-align: right;
    i {
      color: @bule-thame;
      font-size: 18px;
      vertical-align: -2px;
      margin-left: 5px;
    }
  }
  &.noread {
    p.item-cont {
      color: #ccc;
    }
    p.item-header span {
      color: #dc3545;
    }
  }
  .detail {
    color: #3c6eeb;
    margin-left: 30px;
  }
}

.van-collapse-item__content {
  background-color: #f8f8f8;
}
</style>